export var TRANSLATION_NAMESPACE = 'common';
export default {};